// src/components/ui/PhoneField.jsx
// International phone input with a country selector + auto dial code.
// Outputs E.164 (e.g. +46701234567), which the server's PHONE_RE accepts and
// which is the format we'll need for SMS later. Defaults to Canada.
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

export default function PhoneField({ value, onChange, placeholder = "Phone number" }) {
  return (
    <PhoneInput
      international
      defaultCountry="CA"
      limitMaxLength
      value={value || undefined}
      onChange={(val) => onChange(val || "")}
      placeholder={placeholder}
      className="phone-field"
    />
  );
}
